import { render, staticRenderFns } from "./SIReport.vue?vue&type=template&id=9e445d28&"
import script from "./SIReport.vue?vue&type=script&lang=js&"
export * from "./SIReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports